import React, { useState } from 'react';
import Template from '../Components/Template';
import { useGetDeletedExamFormsQuery } from '../Services/modules/exam';

function DeletedFormsList() {
  const [page, setPage] = useState(1);
  const limit = 20;

  const { data, isLoading, isFetching, refetch } = useGetDeletedExamFormsQuery({ page, limit });

  const forms = data?.forms || [];
  const totalCount = data?.totalCount || 0;
  const totalPages = Math.ceil(totalCount / limit);

  return (
    <Template>
      <main id="main" className="main">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
            <h5 className="mb-0">डिलीट केलेले फॉर्म ({totalCount})</h5>
            <button className="btn btn-sm btn-outline-secondary" onClick={refetch} disabled={isFetching}>
              {isFetching ? 'लोडिंग...' : 'रिफ्रेश'}
            </button>
          </div>

          {isLoading ? (
            <p>लोडिंग...</p>
          ) : forms.length === 0 ? (
            <div className="alert alert-info">कोणतेही डिलीट केलेले फॉर्म नाहीत.</div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered table-sm table-hover">
                  <thead className="table-danger">
                    <tr>
                      <th>#</th>
                      <th>नाव</th>
                      <th>परीक्षा</th>
                      <th>इयत्ता</th>
                      <th>शाळा</th>
                      <th>मोबाईल</th>
                      <th>एजंट</th>
                      <th>डिलीट तारीख</th>
                    </tr>
                  </thead>
                  <tbody>
                    {forms.map((form, idx) => (
                      <tr key={form._id}>
                        <td>{(page - 1) * limit + idx + 1}</td>
                        <td>{form.first_name} {form.middle_name} {form.last_name}</td>
                        <td>{form.exam?.exam_name || form.exam_name}</td>
                        <td>{form.exam_standard}</td>
                        <td>{form.school_name}</td>
                        <td>{form.mobile_number}</td>
                        <td>{form.agentId?.full_name || ''} {form.agentId?.agent_id ? `(${form.agentId.agent_id})` : ''}</td>
                        <td>{form.deleted_at ? new Date(form.deleted_at).toLocaleDateString('en-IN') : ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="d-flex gap-2 align-items-center mt-2">
                  <button className="btn btn-sm btn-outline-primary" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>
                    मागे
                  </button>
                  <span>पृष्ठ {page} / {totalPages}</span>
                  <button className="btn btn-sm btn-outline-primary" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
                    पुढे
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </main>
    </Template>
  );
}

export default DeletedFormsList;
